import request from '../utils/request'

export default {
  // 获取所有菜单
  findAll(params) {
    return request.get('/api/menu', { params })
  },
  
  // 根据ID获取菜单
  findById(id) {
    return request.get(`/api/menu/${id}`)
  },
  
  // 添加菜单
  add(menu) {
    return request.post('/api/menu', menu)
  },
  
  // 更新菜单
  update(id, menu) {
    return request.put(`/api/menu/${id}`, menu)
  },
  
  // 删除菜单
  delete(id) {
    return request.delete(`/api/menu/${id}`)
  },

}
